import { StopIteration } from "@axioscode/api-client/lib/utils/APIResponse";
import createAsyncAction from "utils/createAsyncAction";
import dotProp from "dot-prop-immutable";

import Log from "utils/log";

export const GET_CURATION_LIST_REQUESTED = "GET_CURATION_LIST_REQUESTED";
export const GET_CURATION_LIST_SUCCEEDED = "GET_CURATION_LIST_SUCCEEDED";
export const GET_CURATION_LIST_FAILED = "GET_CURATION_LIST_FAILED";

export const getCurationListAsync = createAsyncAction(
  "deepDives",
  "list",
  "GET_CURATION_LIST",
  (args, getState) => [getState().curation.filters]
);

export const GET_CURATION_LIST_NEXT_PAGE_REQUESTED =
  "GET_CURATION_LIST_NEXT_PAGE_REQUESTED";
export const GET_CURATION_LIST_NEXT_PAGE_SUCCEEDED =
  "GET_CURATION_LIST_NEXT_PAGE_SUCCEEDED";
export const GET_CURATION_LIST_NEXT_PAGE_FAILED =
  "GET_CURATION_LIST_NEXT_PAGE_FAILED";

export const getCurationListNextPageRequested = () => {
  return {
    type: GET_CURATION_LIST_NEXT_PAGE_REQUESTED,
  };
};

export const getCurationListNextPageSucceeded = content => {
  return {
    type: GET_CURATION_LIST_NEXT_PAGE_SUCCEEDED,
    payload: content,
  };
};

export const getCurationListNextPageFailed = error => {
  Log.error(error);
  return {
    type: GET_CURATION_LIST_NEXT_PAGE_FAILED,
    payload: error,
    error: true,
  };
};

export const getCurationListNextPageAsync = () => {
  return (dispatch, getState) => {
    const {
      curation: { list },
    } = getState();

    // Only dispatch a next page call if there is a response stored in state which is paginated
    if (dotProp.get(list, "meta.response.count")) {
      const {
        meta: { response },
      } = list;

      return response
        .next()
        .then(list => dispatch(getCurationListNextPageSucceeded(list)))
        .catch(error => {
          // Don't resolve in this catch - throw up to StoryList's _handleInfiniteLoad
          // because this isn't really an error, but we want to use a catch() to handle it still
          if (error instanceof StopIteration) {
            throw error;
          }
          Log.error(error);
          dispatch(getCurationListNextPageFailed(error));
        });
    } else {
      return Promise.resolve();
    }
  };
};
